import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    permissoes: []
  },
  mutations: {
    carregar(state, permissoes) {
      state.permissoes = [];
      state.permissoes = permissoes;
    },
    remover(state, id) {
      state.permissoes = state.permissoes.filter(p => p.id !== id);
    }
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/permissoes?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async listarGrupos() {
      try {
        const response = await securedAxios.get("/permissoes/grupos");
        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    carregarPermissao(context, id_permissao) {
      return securedAxios.get(`/permissoes/${id_permissao}`);
    },
    gravar(context, permissao) {
      if (permissao.id === "") {
        delete permissao.id;
        return securedAxios.post("/permissoes", permissao);
      }
      return securedAxios.put(`/permissoes/${permissao.id}`, permissao);
    },
    async deletar({ commit }, id) {
      try {
        await securedAxios.delete(`/permissoes/${id}`);
        commit("remover", id);
        return Promise.resolve(true);
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }
};
